import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { ApplyPipeModule, AzzurroTable, CalendarPickerModule, CopyToClipboardModule  } from 'ngx-zcs-components';
import { MatChipsModule } from '@angular/material/chips';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { IonicModule } from '@ionic/angular';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { EventsListComponent } from './events-list.component';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    EventsListComponent,
  ],
  imports: [
    ApplyPipeModule,
    AzzurroTable,
    BlockTitleComponent,
    CalendarPickerModule,
    CommonModule,
    CopyToClipboardModule,
    IonicModule,
    MatChipsModule,
    MatIconModule,
    MatSelectModule,
    MatTabsModule,
    MatInputModule,
    MatNativeDateModule,
    MatSortModule,
    MatTableModule,
  ],
  exports: [
    EventsListComponent,
  ],
})
export class EventsListModule { }
